import { createAsyncThunk } from "@reduxjs/toolkit";
import categoryApi from 'api/newshub/categoryApi';


export const getAllCategoriesType = async (params: any = {}) => {
  try {
    const response = await categoryApi.allCategoriesType(params)
    return response;
  } catch (error) {
    return error;
  }
}

